exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputBox[data-v-b798bcc6]{width:590px;height:120px!important}.el-cascader[data-v-b798bcc6]{width:273px}", ""]);

// exports
